import { render, staticRenderFns } from "./ViewDetails.vue?vue&type=template&id=4604c02e&scoped=true&"
import script from "./ViewDetails.vue?vue&type=script&lang=js&"
export * from "./ViewDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetails.vue?vue&type=style&index=0&id=4604c02e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4604c02e",
  null
  
)

export default component.exports